import { useCallback, useState } from 'react';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { firebaseApp } from 'shared/firebase';

export const initialValues = {
  email: '',
  password: '',
};

export const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email()
    .required('Email is required'),
  password: yup.string().required('Password is required'),
});

export const useFormHoc = () => {
  const [error, setError] = useState();
  const history = useHistory();

  const handleSubmit = useCallback(
    (payload, { setSubmitting }) => {
      setError(undefined);
      const { email, password } = payload;

      return firebaseApp
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(({ user }) => {
          if (user) {
            return user.getIdToken(true);
          }

          return Promise.reject(new Error('There is no user with that email'));
        })
        .then(token => {
          localStorage.setItem('cofe-district:id_token', token);
          const { state } = history.location;
          history.push(state?.referrer || '/');
        })
        .catch(({ message }) => setError(message))
        .finally(() => setSubmitting(false));
    },
    [history, setError]
  );

  return {
    error,
    handleSubmit,
  };
};
